export class PaymentReceivedTextSearchRule {
    constructor(public value: string){}
}
